import ReactJsonView from "@microlink/react-json-view";
import { FC } from "react";

import { DATA_E2E_KEY, NO_VALUE_DISPLAY } from "@ryde/shared";

import { CellNotOverflowedStyled } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const JsonViewCellTemplate: FC<IRenderColumnTemplate> = ({
  id,
  value,
  name,
}) => {
  if (!value || typeof value !== "object") {
    return <span>{NO_VALUE_DISPLAY}</span>;
  }

  return (
    <CellNotOverflowedStyled
      {...{ [DATA_E2E_KEY]: "json-view-cell" }}
      data-e2e-id={`${name}_${id}`}
    >
      <ReactJsonView
        src={value}
        name={false}
        displayDataTypes={false}
        enableClipboard={false}
        collapsed
      />
    </CellNotOverflowedStyled>
  );
};
